import styled from 'styled-components/macro';

export const EditModalStyle = styled.div`
  div > span[class*='LabelContainer'],
  div > div > span[class*='LabelContainer'] {
    font-weight: bold;
    font-size: 13px;
    text-align: top;
  }

  div > svg {
    vertical-align: bottom;
  }
`;
